import api from "./apis/api";

class SupplierService {
  create(data) {
    return api.supplier.create(data);
  }
  getList(data) {
    return api.supplier.getList(data);
  }
  getSupplier(id) {
    return api.supplier.getSupplier(id);
  }
  updateSupplier(data) {
    return api.supplier.updateSupplier(data);
  }
  upload(file) {
    return api.supplier.upload(file);
  }
  deleteSupplier(id) {
    return api.supplier.delete(id);
  }
}

export default new SupplierService();
